export const ActionTypes = {
  FETCH_FACTORY_AREA:
    'services/dashboards/vision/liveFactory/fetch_factory_area',
  SET_FACTORY_AREA: 'services/dashboards/vision/liveFactory/set_factory_area',
  FETCH_FACTORY_AREA_DETAILS:
    'services/dashboards/vision/liveFactory/fetch_factory_area_details',
  SET_FACTORY_AREA_DETAILS:
    'services/dashboards/vision/liveFactory/set_factory_area_details',
};

const fetchFactoryArea = () => ({
  type: ActionTypes.FETCH_FACTORY_AREA,
});

const fetchFactoryAreaDetails = id => ({
  id,
  type: ActionTypes.FETCH_FACTORY_AREA_DETAILS,
});

const setFactoryArea = ({ factoryArea }) => ({
  factoryArea,
  type: ActionTypes.SET_FACTORY_AREA,
});

const setFactoryAreaDetails = ({ factoryAreaDetails }) => ({
  factoryAreaDetails,
  type: ActionTypes.SET_FACTORY_AREA_DETAILS,
});

export default {
  fetchFactoryArea,
  fetchFactoryAreaDetails,
  setFactoryArea,
  setFactoryAreaDetails,
};
